import { useCallback, useEffect, useState } from "react";
import { Route, Routes, Outlet, useLocation, Location } from "react-router-dom";
import { AdminPage } from "../pages/Admin/AdminPage";
import { InputPage } from "../pages/Company/InputPage";
import { ConfigReferenciasPage } from "../pages/Company/ConfigReferencias.page";
import { DashboardPage } from "../pages/Company/Dashboard/DashboardPage";
import { LoginPage } from "../pages/LoginPage";
import { RegisterPage } from "../pages/RegisterPage";
import { MainLayout } from "../layouts/Layout";
import { NotFoundPage } from "../pages/Company/NotFoundPage";
import { ListPage } from "../pages/Company/ListPage";
import { CustomFactoresPage } from "../pages/Company/CustomFactores.page";
import { EmpresaPage } from "@/pages/Company/EmpresaPage";
import { EmpresaInputPage } from "@/pages/Company/EmpresaInputPage";
import { ResetPasswordPage } from "../pages/ResetPasswordPage";
function AppRoutes(props: { displayLocation: Location }) {
	// const { user } = useAuth();

	return (
		<Routes location={props.displayLocation}>
			<Route path="/" element={<LoginPage />} />
			<Route path="/login" element={<LoginPage />} />
			<Route path="/register" element={<RegisterPage />} />
			<Route path="/reset-password" element={<ResetPasswordPage />} />

			<Route
				element={
					<MainLayout>
						<Outlet />
					</MainLayout>
				}
			>
				<Route path="/admin">
					<Route index element={<AdminPage />} />
					<Route path="*" element={<NotFoundPage />} />
				</Route>
				<Route path="/user">
					<Route index element={<ListPage />} />
					<Route path="input/:inputId" element={<InputPage />} />
					<Route path="config" element={<ConfigReferenciasPage />} />
					<Route path="configFactores" element={<CustomFactoresPage />} />
					<Route path="dashboard" element={<DashboardPage />} />
					<Route path="empresa" element={<EmpresaPage />} />
					<Route path="empresa/input/:anio" element={<EmpresaInputPage />} />
					<Route path="*" element={<NotFoundPage />} />
				</Route>
			</Route>
		</Routes>
	);
}

export default function TransitionRouter() {
	const location = useLocation();

	const [displayLocation, setDisplayLocation] = useState(location);
	const [transitionStage, setTransitionStage] = useState("fadeIn");

	const onAnimationEnd = useCallback(() => {
		if (transitionStage === "fadeOut") {
			setTransitionStage("fadeIn");
			setDisplayLocation(location);
		}
	}, [location, transitionStage]);

	useEffect(() => {
		// if (
		// 	location.pathname === "/inicio" &&
		// 	displayLocation.pathname === "/login"
		// ) {
		// 	//Cambiamos de router, asi que no vamos a usar animacion
		// 	//TO DO Estaria bien que la primera vez que se renderiza un router el mismo use una animacion?
		// 	setDisplayLocation(location);
		// 	return;
		// }

		if (location !== displayLocation) setTransitionStage("fadeOut");

		// A veces, onAnimationEnd no se llama si se cambia de ruta muy rápido.
		//Esto asegura que se llame, y como solo afecta si estoy en fadeOut, no deberia causar problemas
		setTimeout(onAnimationEnd, 400);
	}, [location, displayLocation, onAnimationEnd]);

	return (
		<div
			className={`${transitionStage} TransitionRoutes`}
			onAnimationEnd={onAnimationEnd}
		>
			<AppRoutes displayLocation={displayLocation} />
		</div>
	);
}
